/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useEffect, useRef, useState } from 'react';
import { jsx } from "@emotion/core";
import './style.css';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setTimer, decreaseTimer, increaseTimer } from '../../redux/slices/timer';
import { setFocusOnTimer } from '../action/utilities';
import { Add, Minus } from '../LandingHeader/Feedback/icons/Icons';

function TimerOptions({defaultOption = 'focusModeSettings'}) {
  const { timer, start } = useSelector(state => state.focusTimer);
  const { settings } = useSelector(state => state.settings);
  const dispatch = useDispatch();
  const timeTabs = [[5, "<span>5</span><span>mins</span>"], [15, "<span>15</span><span>mins</span>"], [30, "<span>30</span><span>mins</span>"], [60, "<span>60</span><span>mins</span>"], [90, "<span>90</span><span>mins</span>"], [120, "<span>120</span><span>mins</span>"]];
  const [hrMinSecValue, setHrMinSec] = useState(0)
  const [selectInputFocus, setselectInputFocus] = useState(false);
  const customTimeInput = useRef('');
  const timerSpan = settings?.timerNudgeAmount ?? 300; // secs

  useEffect(() => {
    !start && setHrMinSec(0);
  }, [start])

  useEffect(() => {
    if(selectInputFocus === false && customTimeInput?.current){
      customTimeInput.current.value = '';
    }
      
  }, [selectInputFocus])

  const setCustomTimeHandler = (e) => {
    setselectInputFocus(true);
    customTimeInput.current.focus();
    setHrMinSec(0)
    const element = document.querySelector('.set-time');
    
    if(element)
      element.style.borderRight = '1px solid rgb(0, 0, 0)';
  }

  const setCustomTime = (e) => {

    let time = isNaN(e.target.value) || e.target.value == '' ? 0 : e.target.value;
    customTimeInput.current.value = time.toString().length > 3 ? time.toString().slice(0, 3) : time;
    setHrMinSec(parseInt(time));
  }

  useEffect(() => {
    if(defaultOption === 'focusMode' && !selectInputFocus)
      return;

    let focusTime = hrMinSecValue
    if(!focusTime){
      const defaultTimePeriod = settings?.defaultTimePeriodFocus ?? '25';
      focusTime = defaultTimePeriod?.replace(/\s/, '') !== '' ? defaultTimePeriod : 0;
    }
    
    dispatch(setTimer(parseInt(focusTime) * 60));
  }, [hrMinSecValue])
  
  const setDefaultTimePeriod = (timerType, timerValue = null) => {
    let defaultTimePeriod = timerValue !== null ? `${timerValue}` : (timerType == 'focus' || timerType == 'focusModeSettings' ? (settings?.defaultTimePeriodFocus ?? '25') : (settings?.defaultTimePeriodBreak ?? '5'));
    setselectInputFocus(false);
    if(defaultTimePeriod){
      const focusTime = defaultTimePeriod?.replace(/\s/, '') !== '' ? parseInt(defaultTimePeriod) * 60 : 0;
      dispatch(setTimer(focusTime));
    }
  }

  const increaseDecreaseTimer = (timerSpan, type) => {
    setselectInputFocus(false);
    type == 'decrease' ? dispatch(decreaseTimer(timerSpan)) : dispatch(increaseTimer(timerSpan));
    setFocusOnTimer();
  }

  const selectedTime = `${selectInputFocus ? hrMinSecValue : timer / 60}`.padStart(2, '0');

  return (
    <div className='flex p-5 items-start gap-5 bg-white dark:bg-black border border-black/5 dark:border-white/5' css={{
        '.actBtns': {
            '&:hover': {
                border: `1px solid var(--accent-color)`,
                background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.90) 0%, rgba(var(--theme-mode-rgb-white), 0.90) 100%), var(--accent-color)`,

                '.path': {
                    stroke: `var(--accent-color)`
                }
            }
        }
    }}>
        <div className='flex p-5 items-center justify-center gap-10 py-[10px] px-5 w-full'>
            <div className='flex items-center justify-between' css={{flex: '1 0 0'}}>
            {
                timeTabs.map((tab, index) =>
                    <button className={`flex items-center justify-center flex-col font-['RL_Madena'] font-normal text-3xl line-height-normal rounded-none time-tab ${timer / 60 == tab[0] ? 'active darkPrimaryColor20' : 'opacity-50'}`} key={index} onClick={e => setDefaultTimePeriod(null, tab[0])} css={{
                        'color': `var(--accent-color)`,
                        'span:first-child': {
                          lineHeight: '30px'
                        },
                        'span:last-child': {
                          fontSize: '14px',
                          lineHeight: '12px'
                        }
                    }} dangerouslySetInnerHTML={{ __html: tab[1] }}>
                </button>
            )}
            </div>
            <div className='flex items-center gap-5'>
                <a href="javascript: void(0);" className='desc actBtns py-[12px] px-[8px] items-start gap-[10px] rounded-[50px] border border-black/10 dark:border-white/10' onClick={e => increaseDecreaseTimer(timerSpan, 'decrease')}>
                    <Minus color='grey'/>
                </a>

                <div className={`flex p-[10px] items-center justify-center flex-col darkPrimaryColor20 font-['RL_Madena']`} id="uu" onClick={setCustomTimeHandler} css={{
                    borderRadius: '20px',
                    border: '1px solid rgba(var(--theme-mode-rgb-white-reverse), 0.08)',
                }}>
                    <span className={`font text-50 darkPrimaryColor20 ${selectedTime == '00' ? 'opacity-20' : ''}`} css={{
                        lineHeight: '50px',
                        borderRight: selectInputFocus ? '1px solid rgba(var(--theme-mode-rgb-white-reverse), 0.5)' : 'none'
                    }}>{selectedTime}</span>
                    <span className='text-xl'>mins</span>
                </div>
                
                <input className="timer-custom-time" ref={customTimeInput} onInput={setCustomTime} />

                <a href="javascript: void(0);" className='ased actBtns py-[12px] px-[8px] items-start gap-[10px] rounded-[50px] border border-black/10 dark:border-white/10' onClick={e => increaseDecreaseTimer(timerSpan, 'increase')}>
                    <Add color='grey' />
                </a>
            </div>
        </div>
    </div>
  )
}

export default TimerOptions